// extracted by mini-css-extract-plugin
export default {"wrapper":"sbn_S","title":"XfilS","description":"KJ1y1","link":"rb8oG","linkIcon":"z_H18"};